import { PortColor } from "../../../utils/appConstants";
import LinkImage from "../../ResourceImages/Link";

interface LinkStatusInterface {
  bandwidthPort: any;
}

const getPlugColor = (color: PortColor.Green | PortColor.Grey, hasCrossConnect: boolean) => {
  if (color === PortColor.Green) {
    if (hasCrossConnect) {
      return PortColor.Green;
    } else {
      return PortColor.LightGreen;
    }
  } else {
    if (hasCrossConnect) {
      return PortColor.Grey;
    } else {
      return PortColor.LightGrey;
    }
  }
};

const LinkStatus: React.FC<LinkStatusInterface> = ({ bandwidthPort }) => {
  const size = 120;
  if (bandwidthPort.status === "put_up_for_sale_bandwidth") {
    return (
      <LinkImage
        leftColor={PortColor.Yellow}
        rightColor={PortColor.Yellow}
        leftPlug={PortColor.LightYellow}
        rightPlug={PortColor.LightYellow}
        linkColor={PortColor.Yellow}
        size={size}
      />
    );
  }
  if (bandwidthPort.status === "sold") {
    return (
      <LinkImage
        size={size}
        leftColor={PortColor.Red}
        rightColor={PortColor.Red}
        leftPlug={PortColor.Red}
        rightPlug={PortColor.Red}
        linkColor={PortColor.Red}
      />
    );
  }
  const linkColor = bandwidthPort.is_verified ? PortColor.Green : PortColor.Grey;
  const leftColor = bandwidthPort.nearend_verified ? PortColor.Green : PortColor.Grey;
  const leftPlug = getPlugColor(leftColor, bandwidthPort.added_near_cross_connect);
  const rightColor = bandwidthPort.farend_verified ? PortColor.Green : PortColor.Grey;
  const rightPlug = getPlugColor(rightColor, bandwidthPort.added_far_cross_connect);
  return <LinkImage size={size} leftColor={leftColor} rightColor={rightColor} leftPlug={leftPlug} rightPlug={rightPlug} linkColor={linkColor} />;
};
export default LinkStatus;

/*const getLinkImage = () => {
    if (bandwidthPort.status === "put_up_for_sale_bandwidth") {
      return LinkYellow;
    }
    if (bandwidthPort.status === "sold") {
      return LinkRed;
    }
    if (bandwidthPort.nearend_verified && bandwidthPort.farend_verified && bandwidthPort.is_verified) {
      if (bandwidthPort.status === "in_use") {
        return LinkGreenConsumed;
      }
      return LinkGreenAvailable;
    }
    return LinkGrey;
  };*/
